import { Outlet } from 'react-router';
import { SkipLink } from './SkipLink';

export function PublicLayout() {
  return (
    <>
      <SkipLink />
      <main
        id="main"
        tabIndex={-1}
        className="mx-auto flex min-h-dvh w-full max-w-3xl flex-col px-4 py-6 outline-none"
      >
        <Outlet />
      </main>
    </>
  );
}
